<app-academies-header></app-academies-header>
<section class="body-section academies-profile-inner">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
                        <h3 class="section-header">WOW FACTOR / ACHIEVEMENTS
                        </h3>

                        <div class="add-edit-btn">
                            <ul>
                                <li>
                                    <button class="add-btn-main" (click)="openmodal()">
                                        <i class='bx bx-plus'></i> Add
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <div class="col-md-12 p-0">
                        <div class=" swiper high-light-slider">

                            <div *ngFor="let highlight of highlightlist " class="list-heighlight"
                                style="width: 292.25px;margin-right: 5px;">
                                <div class="heiglght-div card">
                                    <div class="edit-button-show-click">
                                        <button (click)="onClickEdit(highlight.id)"><i
                                                class='bx bx-pencil'></i></button>
                                        <button class="delete-btn" (click)="onClickDelete(highlight)"><i
                                                class='bx bx-trash '></i></button>
                                    </div>
                                    <div class="image">
                                        <img src="{{highlight.image}}" alt="" class="w-100">
                                    </div>
                                    <div class="headigns">
                                        <h4>{{highlight.heading}}</h4>
                                    </div>
                                    <p class="subhead">{{highlight.descriptions}}</p>
                                </div>
                            </div>

                        </div>
                        <!-- <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-pagination"></div> -->
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>


<!-- Modal -->
<p-dialog header="Header" [closable]="true" [(visible)]="showingForm" [modal]="true" [style]="{width: '25vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" (onHide)="onHighlightModalClose()"
    [draggable]="false" [resizable]="false" class=" add-edit-modal">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{pagetitle}}</span>
    </ng-template>
    <div class="modal-body">
        <form class="form" [formGroup]="highlightform" (ngSubmit)="onsubmit()">
            <label for="name_login mb-3">Upload Image</label>
            <div class="col-md-12 upload-image-div">
                <img *ngIf="showUploadedpic" id="blah" src="{{imagehighlight}}" />
                <!-- <img *ngIf="!showUploadedpic" id="blah" src="assets/img/acadmy-details/180.png" alt="your image" /> -->
                <p-fileUpload name="myfile[]" maxFileSize="{{imageSize}}" customUpload="true"
                    (uploadHandler)="picUploader($event)" accept="image/*" auto="auto">
                </p-fileUpload>
            </div>
            <div class="row">
                <div class="col p-0">

                    <div class="p-field p-col-12 mb-0">
                        <label for="heading">Heading
                            <span class="mandatory-fields">*</span></label>
                        <input formControlName="heading" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': ((submitted && f.heading.errors) || (f.heading.errors && (f.heading.dirty || f.heading.touched))) }"
                            placeholder="Enter Heading">
                        <div *ngIf="((submitted && f.heading.errors) || (f.heading.errors && (f.heading.dirty || f.heading.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.heading.errors.required">
                                Heading is required.</div>
                            <div *ngIf="!f.heading.errors.required">
                                Please enter valid Highlight.</div>
                        </div>
                    </div>

                    <div class="p-field p-col-12  mb-0 pt-0">
                        <label for="descriptions" class="w-100">Description</label>
                        <textarea class="w-100" inputId="textarea" rows="3" cols="50" formControlName="descriptions"
                            placeholder="Enter Description" pInputTextarea></textarea>
                    </div>
                    <!-- <div class="p-field p-col-12  mb-0  pt-0">
                        <label for="url">Website URL <span class="mandatory-fields">*</span></label>
                        <input formControlName="url" type="text" pInputText class="form-control"
                            [ngClass]="{ 'is-invalid': ((submitted && f.url.errors) || (f.url.errors && (f.url.dirty || f.url.touched)))  }"
                            placeholder="Enter Website URL  ">
                        <div *ngIf="((submitted && f.url.errors) || (f.url.errors && (f.url.dirty || f.url.touched)))"
                            class="invalid-feedback">
                            <div *ngIf="f.url.errors.required">
                                Website URL is required.</div>
                            <div *ngIf="f.url.errors.pattern">
                                Please enter valid Website url.</div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <!-- <button type="button" class="btn btn-primary" (click)="onsubmit()">Save changes</button> -->
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAddMode">Save </span>
                    <span *ngIf="!isAddMode">Update</span>
                </button>
            </div>
        </form>
    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>